// extracted by mini-css-extract-plugin
module.exports = {"container":"MCardBody_container__17PLa"};